import { render, staticRenderFns } from "./AiReception.vue?vue&type=template&id=f566206c&scoped=true"
import script from "./AiReception.vue?vue&type=script&lang=js"
export * from "./AiReception.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f566206c",
  null
  
)

export default component.exports